import React from 'react';

import Icon from 'flow/components/ui-components/Icon';
import { MeetingProviderType } from 'flow/types/Meetings';
import { providerIconKey } from './today-meetings-utils';

type Props = {
    meetingType: MeetingProviderType;
};

// Every provider mark occupies the same 20px box the design specifies. The
// sizing rule targets the rendered <svg> from a wrapper — and has to win over
// an inline style — because the brand icons are custom SvgIcon components that
// hard-code width/height inline and ignore the `size` Icon passes down.
//
// Brand icons carry their own colors; the gray text color only affects the
// generic (currentColor) video/calendar icons used for internal/webex/other.
const MeetingProviderIcon = ({ meetingType }: Props) => (
    <span className="flex size-5 shrink-0 items-center justify-center text-gray-600 [&>svg]:size-5!">
        <Icon iconKey={providerIconKey(meetingType)} size="1.25rem" />
    </span>
);

export default MeetingProviderIcon;
